import { createContext, useContext, type ReactNode } from 'react';

export const DEMO_RESOURCE_SERVER_IDENTIFIER = 'https://clique-test.com';

export interface DemoPermissionScopeValue {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
  identifier: string;
}

const DemoPermissionScopeContext = createContext<DemoPermissionScopeValue | null>(null);

export function DemoPermissionScopeProvider({
  value,
  children,
}: {
  value: DemoPermissionScopeValue;
  children: ReactNode;
}) {
  return (
    <DemoPermissionScopeContext.Provider value={value}>
      {children}
    </DemoPermissionScopeContext.Provider>
  );
}

export function useDemoPermissionScope(): DemoPermissionScopeValue {
  const ctx = useContext(DemoPermissionScopeContext);
  if (!ctx) {
    throw new Error('useDemoPermissionScope must be used within DemoPermissionScopeProvider.');
  }
  return ctx;
}
